import React, {useMemo} from 'react';
import AutoField, {ActionType, SelectAutocompleteField} from '../AutoForm/AutoFieldNew';
import {useAccountContext} from '../../contexts/AccountContext';

export const ParentGuardianSearch: React.FC<{formikKeyPrefix: string}> = ({
  formikKeyPrefix,
}) => {
  const {account, accountLoading} = useAccountContext();
  const searchField = useMemo(() => {
    const field: SelectAutocompleteField = {
      type: ActionType.selectAutocomplete,
      id: `${formikKeyPrefix}.parentGuardianId`,
      label: 'Parent / Guardian',
      fullWidth: true,
      size: 'medium',
      options:
        account?.contacts
          ?.filter((x) => !x.isMinor)
          .map((x) => ({
            label: x!.name!,
            value: x!.id as any,
          })) || [],
      loading: accountLoading,
    };
    return field;
  }, [account, accountLoading, formikKeyPrefix]);

  return <AutoField field={searchField} />;
};
